const deviceStatusLib = {
	Proposed: {
		Id: 1,
		color: "#ccc",
		status: "Proposed",
		formattedText: "Proposed"
	},
	TFMApproval: {
		Id: 2,
		color: "#fade44",
		status: "TFMApproval",
		formattedText: "TFM Approval"
	},
	Deployed: {
		Id: 3,
		color: "#0c3",
		status: "Deployed",
		formattedText: "Deployed"
	},
	Maintenance: {
		Id: 4,
		color: "#4cf",
		status: "Maintenance",
		formattedText: "In Maintenance"
	},
	Removed: {
		Id: 5,
		color: "",
		status: "Removed",
		formattedText: "Removed"
	}
};

export default deviceStatusLib;
